export default __webpack_public_path__ + "static/media/children_implications.27f1cced.svg";